import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

export function useMaintenanceGetByAircraft(
  aircraftId: string,
  options?: { enabled?: boolean }
) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(
    orpc.maintenance.getByAircraft.queryOptions({
      input: { aircraftId },
      enabled: !!aircraftId && (options?.enabled ?? true),
    })
  )
}

// Invalidate both the maintenance list and the aircraft cache: an added/removed
// window changes the aircraft's derived status, badges, and list-view counts.
function useMaintenanceInvalidate(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: orpc.maintenance.getByAircraft.key({ input: { aircraftId } }),
    })
    queryClient.invalidateQueries({ queryKey: orpc.aircraft.key() })
  }
}

export function useMaintenanceCreate(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const invalidate = useMaintenanceInvalidate(aircraftId)
  return useMutation(
    orpc.maintenance.create.mutationOptions({
      onSuccess: invalidate,
    })
  )
}

export function useMaintenanceUpdate(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const invalidate = useMaintenanceInvalidate(aircraftId)
  return useMutation(
    orpc.maintenance.update.mutationOptions({
      onSuccess: invalidate,
    })
  )
}

export function useMaintenanceDelete(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const invalidate = useMaintenanceInvalidate(aircraftId)
  return useMutation(
    orpc.maintenance.delete.mutationOptions({
      onSuccess: invalidate,
    })
  )
}
